import React from 'react';
import speedometer from '../../assets/img/speedometer.svg';
import gasolinePump from '../../assets/img/gasoline-pump.svg'
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import { useHistory, useParams } from "react-router-dom";
import API from "../../Services/BaseService";
import { useState } from 'react';
import { useEffect } from 'react';
import UrCarAction from './UrCarAction';
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import Popup from "../../Component/Popup/Popup";

import PageNotFound from '../FallBackUI/PageNotFound';
import ls from "local-storage";
import odometer from '../../assets/img/miles.jpg';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import wsBaseURL from '../../Services/Constant';
// import { w3cwebsocket as W3CWebSocket } from "websocket";
import 'bootstrap/dist/css/bootstrap.min.css';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';

// const ws=new WebSocket(wsBaseURL);
// const contentDefaultMessage = "Start writing your document here";
import UrCarBidList from "../../Container/UrCardetails/UrBidlist";
import SealedBidHome from '../../Container/UrCardetails/SealedBidHome';
const Carlist = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [carDetail, setCarDetail] = useState([]);
  const [allcarDetail, setAllCarDetail] = useState([]);
  const [soldcarDetail, setSoldCarDetail] = useState([]);
  const successData = useSelector(state => state.LoginReducer.payload);
  const dealerData = useSelector(state => state.DealerReducer.payload);
  const [isOpenBidList, setisOpenBidList] = useState(false);
  const [isOpenCarHistory, setIsOpenCarHistory] = useState(false);
  const [bidId, setBidId] = useState("");

  const togglePopupBidList1 = (data) => {
    setBidId(data)
    togglePopupBidList()
  }
  const togglePopupBidList = () => {
    setisOpenBidList(!isOpenBidList);
  }
  const togglePopupCarHistory1 = (data) => {
    setBidId(data)
    togglePopupCarHistory()
  }
  const togglePopupCarHistory = () => {
    setIsOpenCarHistory(!isOpenCarHistory);
  }
  const CustomPrevArrow = (props) => (
    <button {...props} className="custom-prev-arrow">
      &lt; {/* Left arrow */}
    </button>
  );

  const CustomNextArrow = (props) => (
    <button {...props} className="custom-next-arrow">
      &gt; {/* Right arrow */}
    </button>
  );



  const responsiveSettings = [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
  ];

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const backUrl = ls.get("backredirection");
  console.log("check the back url", backUrl);
  const back = backUrl[(backUrl.length) - 1];
  console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);

  console.log("successData====2222==", successData)

  //   useEffect(()=>{

  //     setTimeout(()=>{
  //         wsCall()
  //     },3000)


  // },[])

  // const wsCall = () => {

  //   ws.onopen = () => {
  //       console.log('WebSocket ws Connected');
  //   };

  //   console.log('wsCall===========>', );

  //   ws.send(JSON.stringify({seller_dealer_id:successData.seller_dealer_id,seller_id:successData.seller_id,seller_token:successData.seller_token  ,model:'recentlysoldcars'}))

  //   ws.onmessage = (message) => {
  //       console.log("check the message ===",message)
  //       const dataFromServer = JSON.parse(message.data)
  //       console.log("check the  data FromServer", dataFromServer)

  //       switch(dataFromServer[1]) {


  //           case "recentlysoldcars":
  //             getsoldcar (dataFromServer[0]);
  //               break;

  //           default:

  //       }



  //   }

  // }

  const getsoldcar = (data) => {
    let request = {
      // seller_dealer_id: successData.seller_dealer_id,
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

      seller_id: successData.seller_id,
      seller_token: successData.seller_token
    }
    console.log("+++++++++==++", request)
    API.post('recentlysoldcars/condition', request).then(res => {
      console.log(" sold response", res.data.data);
      // const {results} = res.data.data;
      console.log("sold Response data", res.data.data);
      //if(results.length>0){
      setSoldCarDetail(res.data.data);
      console.log("soldcarDetail", res.data.data);
      setLoading(false);
      //}
      //setrecentCarFlag(!recentCarFlag)
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
        setLoading(false);
      }
    });
  }
  const soldredirectpage = (pathid, seller_data, transportation_flag) => {
    // console.log("seller_dealer_id+++++",seller_dealer_id)
    dispatch(UrCarAction.sellerid(seller_data))
    // history.push("/cardetails/"+pathid);
    history.push({
      pathname: "/soldcardetails",
      state: { backURL: "/recentlysoldcars", id: pathid, transportationFlag: transportation_flag },
    }); ls.set("backredirection", [...backUrl, "/recentlysoldcars"])
  }
  // const rerunCarPage=(pathid,seller_data)=>{
  //   // console.log("seller_dealer_id+++++",seller_dealer_id)
  //   dispatch(UrCarAction.sellerid(seller_data))
  //   history.push("/reRunCarDetails/"+pathid);
  // }
  useEffect(() => {
    let intervalId;
    intervalId = setInterval(() => {
      //getrecentlycar();
      // getallcar();
      getsoldcar(dealerData);
    }, 10000)
    return () => clearInterval(intervalId);
  }, [])
  useEffect(() => {
    //getrecentlycar();
    // getallcar();
    getsoldcar(dealerData);
  }, []);

  const [showPopover, setShowPopover] = useState(Array(carDetail.length).fill(false));
  const [carPrice, setCarPrice] = useState("")

  const handleBackButtonClick = (index, item) => {
    console.log(item, "item");
    setShowPopover(prevShowPopover => {
      const newShowPopover = [...prevShowPopover];
      newShowPopover[index] = !newShowPopover[index];
      return newShowPopover;
    });
    setCarPrice(item)
  }

  const totalPrice = Number(carPrice.max_price) -
    (Number(carPrice?.bos_seller_fee) +
      Number(carPrice?.bos_sellerothertotalcharges) +
      Number(carPrice?.bos_car_charges));

  const popover = (
    <Popover id="popover-basic" className="custom-popover">
      <Popover.Title as="h3">Vehicle Price</Popover.Title>
      <Popover.Content >
        <div className="row">
          <div class="col-lg-12 pt-4 pt-lg-0 feestableBlock">
            <div class="feestable">
              <p>Price - <span>$ {carPrice.max_price}</span></p>
              <p>Sell Fee - <span>$ {carPrice.bos_seller_fee}</span></p>
              <p>Other Charges - <span>$ {carPrice.bos_sellerothertotalcharges}</span></p>
              <p>Miscellaneous Charges - <span>$ {carPrice.bos_car_charges}</span></p>
              <p>Total Price - <span>$ {totalPrice}</span></p>


            </div>
          </div>
        </div>
      </Popover.Content>
    </Popover>
  );

  return (
    <div>
      {loading ? <Loading /> :
        <main id="main" class="">

          {errorFlag === true ? <PageNotFound error={errors} /> :
            <div id="recently-cars" class="recently-cars soldCars" >
              <div class="container-fluid inner-page-space aos-init aos-animate" >


                <div class="common-heading">
                  <div className="row">
                    <div className="col-lg-4">
                      <div class="back-btn">
                        <a class="back-btn-primary" onClick={() => history.push("/carlist")}><i class="bx bx-chevron-left"></i> Back</a>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div class="title">
                        <p class="inner-title">Recently Sold cars</p>
                      </div>
                    </div>

                    {window.innerWidth >= 992 ? (



                      <div class="row aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
                        {soldcarDetail?.length > 0 ? soldcarDetail
                          .map((item, index) =>

                            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6" >
                              <div class="car-item ">

                                <div class="soldRibbon">
                                  <h4 class="ribbon">Sold Car</h4>
                                </div>

                                <img src={item.image} class="carImg" alt="..." onClick={() => { soldredirectpage(item.carid, item, item.title_status_name, item.transportation_flag, item.seller_dealer_id) }} />
                                <div class="cars-content">
                                  <h3><a >{item.year} {item.make} {item.model} </a></h3>

                                  <div class="km-petrol">
                                    <p class="details"><img src={speedometer} alt="" /><span>{item.mileage} {item.mileage_type}</span></p>
                                    {item.fuel_type == "null" || item.fuel_type == null || item.fuel_type == "" || item.fuel_type == "undefined" || item.fuel_type == undefined ? "" :
                                      <p class="details"><img src={gasolinePump} alt="" /><span>{item.fuel_type}</span></p>}
                                  </div>
                                  <div className='make-bit'>
                                    {item.label_type === "Sealed Bid Sales" ?
                                      <a class="sealedbid"><span> {item.label_type.substr(0, 10)}</span></a>
                                      :
                                      <a class="makebit"><span> {item.label_type}</span></a>
                                    }
                                    {item.label_type === "Sealed Bid Sales" ?
                                      <a class="cars-buy-btns redBtn butnpad" onClick={() => togglePopupCarHistory1(item.carid)} >Bid Details</a> :
                                      <a class="cars-buy-btns redBtn butnpad" onClick={() => togglePopupBidList1(item.carid)} >Bid Details</a>
                                    }
                                  </div>

                                  <div class="odometer">
                                    <p class="details"><img src={odometer} alt="" /><span>Is Odometer working</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                  </div>

                                  <div class="cars-prices">
                                    {item.sold_price == "" || item.sold_price == undefined || item.sold_price == null ? "" :
                                      <div class="prices">
                                        <a class="cta-btns SellPrice" >Sold : <span> $ {item.sold_price} </span></a>
                                      </div>}
                                  </div>
                                </div>
                              </div>
                            </div>) : <div class="col-lg-12 nodata"><p>No Data Found</p> </div>}

                      </div>



                    )
                      : (

                        <div class="row">



                          {soldcarDetail?.length > 0 ?

                            <Slider
                              dots={false}
                              infinite={false}
                              speed={500}
                              responsive={responsiveSettings}
                              centerMode={false}
                            >
                              {soldcarDetail.map((item, index) =>

                                <div class="" >
                                  <div class="car-item ">

                                    <div class="soldRibbon">
                                      <h4 class="ribbon">Sold Car</h4>
                                    </div>


                                    <img src={item.image} class="carImg" alt="..." onClick={() => { soldredirectpage(item.carid, item, item.transportation_flag) }} />
                                    <div class="cars-content">
                                      <h3><a >{item.year} {item.make} {item.model} </a></h3>

                                      <div class="km-petrol">
                                        <p class="details"><img src={speedometer} alt="" /><span>{item.mileage} {item.mileage_type}</span></p>
                                        {item.fuel_type == "null" || item.fuel_type == null || item.fuel_type == "" || item.fuel_type == "undefined" || item.fuel_type == undefined ? "" :
                                          <p class="details"><img src={gasolinePump} alt="" /><span>{item.fuel_type}</span></p>}
                                      </div>
                                      <div className='make-bit'>
                                        {item.label_type === "Sealed Bid Sales" ?
                                          <a class="sealedbid"><span> {item.label_type.substr(0, 10)}</span></a>
                                          :
                                          <a class="makebit"><span> {item.label_type}</span></a>
                                        }
                                        {item.label_type === "Sealed Bid Sales" ?
                                          <a class="cars-buy-btns redBtn butnpad" onClick={() => togglePopupCarHistory1(item.carid)} >Bid Details</a> :
                                          <a class="cars-buy-btns redBtn butnpad" onClick={() => togglePopupBidList1(item.carid)} >Bid Details</a>
                                        }
                                      </div>

                                      <div class="odometer">
                                        <p class="details"><img src={odometer} alt="" /><span>Is Odometer working</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                      </div>

                                      <div class="cars-prices">
                                        {item.sold_price == "" || item.sold_price == undefined || item.sold_price == null ? "" :
                                          <div class="prices">
                                            <a class="cta-btns SellPrice" >Sold : <span> $ {item.sold_price} </span></a>
                                          </div>}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Slider>
                            : <div class="col-lg-12 nodata"><p>No Data Found</p> </div>}

                        </div>)
                    }


                  </div>
                </div>
              </div>
            </div>}
          {isOpenCarHistory && <Popup
            isClose={false}
            content={<>
              <SealedBidHome toggle={togglePopupCarHistory} carId={bidId} />
            </>}
            handleClose={togglePopupCarHistory}
          />}
          {isOpenBidList && <Popup
            isClose={false}
            content={<>
              <UrCarBidList toggle={togglePopupBidList} carId={bidId}/*  time={time} countBid={countBid} newBid={newBid} */ />
            </>}
            handleClose={togglePopupBidList}
          />}
          <section id="playstoreBlock" class="playstoreBlock">
            <div class="container">
              <div class="row content">
                <div class="col-lg-12">
                  <img src={appstore} />
                  <img src={googleplay} />
                </div>

              </div>

            </div>
          </section>
        </main>}
    </div>
  )
}
export default Carlist;